import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap, retry, switchMap, tap } from 'rxjs/operators';

import * as templateActions from '../actions/templates.action';
import { TemplatesService } from '../../_shared/services/templates/templates.service';

@Injectable()
export class TemplatesEffects {
  constructor(
    private actions$: Actions,
    private templatesService: TemplatesService
  ) {}

  loadTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(templateActions.loadTemplates),
      mergeMap(res => {
        return this.templatesService.loadPaginated().pipe(
          map(templates => {
            return templateActions.loadTemplatesSuccess({ payload: templates });
          }),
          catchError(err => of(templateActions.loadTemplatesFail(err)))
        );
      })
    )
  );

  loadMoreTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(templateActions.loadMoreTemplates),
      mergeMap(res => {
        return this.templatesService.loadMore(res.payload.skip, res.payload.limit).pipe(
          map(templates => templateActions.loadMoreTemplatesSuccess({ payload: templates })),
          catchError(err => of(templateActions.loadMoreTemplatesFail(err)))
        );
      })
    )
  );

  loadAllTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(templateActions.loadAllTemplates),
      mergeMap(res => {
        return this.templatesService.loadAll().pipe(
          map(templates => templateActions.loadAllTemplatesSuccess({ payload: templates.result.results })),
          catchError(err => of(templateActions.loadAllTemplatesFail(err)))
        );
      })
    )
  );

  searchTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(templateActions.searchTemplates),
      switchMap(res => {
        return this.templatesService.search(res.payload.query).pipe(
          distinctUntilChanged(),
          debounceTime(500),
          map(templates => templateActions.searchTemplatesSuccess({ payload: templates.result.results })),
          catchError(err => of(templateActions.searchTemplatesFail(err)))
        );
      })
    )
  );
}
